module.exports = __webpack_public_path__ + "img/0.ec7edfa3.svg";